module.exports = __webpack_public_path__ + "img/wpusz.7020a884.jpg";